import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import finalIcon from "../../../../../assets/design-revamp-company/company-detail-headers/final-treatment-icon.svg";
import { useTranslation } from "react-i18next";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import {
  getProductFinalTreatment,
  createSystemBoundaryProductFinalTreatment,
} from "../../../../../apis/Product/ProductFinalTreatmentApi";

const FinalTreatmentIcon = () => (
  <img
    src={finalIcon}
    alt="Processing Intermediate Icon"
    width={76}
    height={76}
  />
);

const FinalTreatmentHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  productId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjProcessing, setTotalObjProcessing] = useState([]);
  const [systemBoundaryProcess, setSystemBoundaryProcess] = useState("");
  useEffect(() => {
    getProductFinalTreatment({
      id: productId,
      setProdInv: setTotalObjProcessing,
      setSystemBoundary: setSystemBoundaryProcess,
    });
  }, [productId]);

  return (
    <CategoryComponent
      show={show}
      className={`final-treatment-category ${className || ""}`}
      leftBoxProps={{
        icon: <FinalTreatmentIcon />,
        title: t("FINAL_TREATMENT_PRODUCTS"),
        description: t("COMP_FINAL_TREATMENT_DESC"),
        scopes: [{ scope: "Scope 3", filled: true }],
        isSystemBoundary: true,
        systemBoundary: systemBoundaryProcess,
        setSystemBoundary: setSystemBoundaryProcess,
        productId: productId,
        createSystemBoundaryFunc: createSystemBoundaryProductFinalTreatment,
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_LIFECYCLE_PHASE"),
            items: [
              {
                subtitle: t("EMISSIONS"),
                subitems: [
                  {
                    value: `${
                      totalObjProcessing
                        ? handleToFixedNum(
                            totalObjProcessing,
                            totalObjProcessing?.total_carbon
                          )
                        : "xx"
                    } (tCO₂e)`,
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjProcessing?.updated_at
          ? formatDate(totalObjProcessing?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default FinalTreatmentHeader;
